// Reads in option order, not pick order, so the same selection always reads the same way.
export function multiSelectSummary(selected: string[], options: { value: string; label: string }[]): string {
	const chosen = new Set(selected);
	return options
		.filter((option) => chosen.has(option.value))
		.map((option) => option.label)
		.join(', ');
}

export const MULTI_SELECT_ALL_VALUE = '__multi-select-all__';

// cmdk falls back to an item's text for its value, and the ticked state is spoken as text, so the identity and what
// search matches are set explicitly.
export function multiSelectItemSearch(option: { value: string; label: string }): { value: string; keywords: string[] } {
	return { value: option.value, keywords: [option.label] };
}
